import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectAttendanceAlertsEventPayload } from 'src/app/models/event-payloads.model';
import { AttendanceItemViewModel } from 'src/app/models/item.model';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { AttendancePublisherComponent } from '../attendance-publisher/attendance-publisher.component';
import { HubItemMessageComponent } from '../hub-item-message/hub-item-message.component';
import { ListItemHeaderComponent } from '../list-item-header/list-item-header.component';

@Component({
  selector: 'app-attendance-item',
  templateUrl: './attendance-item.component.html',
  styleUrls: ['./attendance-item.component.scss'],
  imports: [ListItemHeaderComponent, HubItemMessageComponent, AttachmentsComponent, AttendancePublisherComponent]
})
export class AttendanceItemComponent {
  @Input() item: AttendanceItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectItem = new EventEmitter<string>();
  @Output() selectStudent = new EventEmitter<number>();
  @Output() selectAttendanceAlerts = new EventEmitter<SelectAttendanceAlertsEventPayload>();
  @Output() openAttachment = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();
}
